// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCH746EWVqGCWkJK2_L_jAsxTqKsWAZ5xM",
  authDomain: "nationalfinanceolympiad.firebaseapp.com",
  projectId: "nationalfinanceolympiad",
  storageBucket: "nationalfinanceolympiad.firebasestorage.app",
  messagingSenderId: "252764224636",
  appId: "1:252764224636:web:3790c9f79a9a1c0b4bddf9",
  measurementId: "G-EPRWG5XVQ5",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const configuration = {
  enableAdBlockDetection: true,
  production: true,
  debug: false,
  sentry: {
    enable: true,
  },
  googleAnalytics: {
    enable: true,
  },
  // Coupon Configuration
  coupon: {
    enableForPrepaid: true, // Set to false to disable coupons for prepaid payments
    enableForCOD: true, // Set to false to disable coupons for COD payments
    enabled: true, // Master switch - set to false to disable coupons entirely
  },
};
